<div class="mat-elevation-z8">
  
  <!-- Filter Timesheet Form -->
  <form [formGroup]="filterForm" (ngSubmit)="onFilter()" class="timesheet-form">
    <h5>Filter Timesheet</h5>
    <div class="form-row">
      
      <!-- Category Selection -->
      <div class="field">
        <mat-form-field appearance="outline">
          <mat-label>Category</mat-label>
          <mat-select formControlName="categoryIds" multiple="true" (selectionChange)="onfilterCategorySelection($event.value)">
            <mat-option>
              <ngx-mat-select-search
              [formControl]="categorySearch.multiFilterCtrl"
              [placeholderLabel]="'Search Category'"
              [noEntriesFoundLabel]="'No Category Found'"
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="categorySearch.isIndeterminate"
              [toggleAllCheckboxChecked]="categorySearch.isChecked"
              (toggleAll)="categorySearch.toggleSelectAll($event)"
              ></ngx-mat-select-search>
            </mat-option>
            @for (category of categorySearch.filteredMulti | async; track category) {
              <mat-option [value]="category.id">{{category.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      
      <!-- Activity Selection -->
      <div class="field">
        <mat-form-field appearance="outline">
          <mat-label>Activity</mat-label>
          <mat-select formControlName="activityIds" multiple="true">
            <mat-option>
              <ngx-mat-select-search
              [formControl]="activitySearch.multiFilterCtrl"
              [placeholderLabel]="'Search Activity'"
              [noEntriesFoundLabel]="'No Activity Found'"
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="activitySearch.isIndeterminate"
              [toggleAllCheckboxChecked]="activitySearch.isChecked"
              (toggleAll)="activitySearch.toggleSelectAll($event)"
              ></ngx-mat-select-search>
            </mat-option>
            @for (activity of activitySearch.filteredMulti | async; track activity) {
              <mat-option [value]="activity.id">{{activity.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      
      <!-- User Selection -->
      @if(isAdmin || isTeamlead || isDepartmentAdmin){
        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>User</mat-label>
            <mat-select formControlName="userIds" multiple="true">
              <mat-option>
              <ngx-mat-select-search
              [formControl]="userSearch.multiFilterCtrl"
              [placeholderLabel]="'Search User'"
              [noEntriesFoundLabel]="'No User Found'"
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxIndeterminate]="userSearch.isIndeterminate"
              [toggleAllCheckboxChecked]="userSearch.isChecked"
              (toggleAll)="userSearch.toggleSelectAll($event)"
              ></ngx-mat-select-search>
              </mat-option>
              @for (user of userSearch.filteredMulti | async; track user) {
                <mat-option [value]="user.id">{{user.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }

      <!-- Status Selection -->
      <div class="field">
        <mat-form-field appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status" multiple="true">
              <mat-option>
                <ngx-mat-select-search
                [formControl]="statusSearch.multiFilterCtrl"
                [placeholderLabel]="'Search Status'"
                [noEntriesFoundLabel]="'No Status Found'"
                [showToggleAllCheckbox]="true"
                [toggleAllCheckboxIndeterminate]="statusSearch.isIndeterminate"
                [toggleAllCheckboxChecked]="statusSearch.isChecked"
                (toggleAll)="statusSearch.toggleSelectAll($event)"
                ></ngx-mat-select-search>
              </mat-option>
              @for (status of statusSearch.filteredMulti | async; track status) {
                <mat-option [value]="status.id">{{status.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
      </div>
      
      <div class="field">
        <mat-form-field appearance="outline" class="start-date-field">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startDatePicker" formControlName="startDate">
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      
      <div class="field">
        <mat-form-field appearance="outline" class="end-date-field">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endDatePicker" formControlName="endDate">
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      
      <button mat-raised-button color="primary" type="submit">Filter</button>
      <button mat-raised-button color="primary" (click)="clearFilter()" type="button">Clear</button>
    </div>
  </form>
  @if(isAdmin || isTeamlead || isDepartmentAdmin){
    <div>
      <button mat-raised-button color="primary" (click)="setTimeSheetStatus(1)">Verify</button> &nbsp;
      <button mat-raised-button color="primary" (click)="setTimeSheetStatus(0)">Unverify</button>
    </div>
  }
  <mat-paginator [length]="totalItemsCount" [pageSize]="pageSize" 
  [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons 
  (page)="onPageChange($event)"></mat-paginator>
  <div class="table-container">
  <table mat-table [dataSource]="timesheets" class="my-table">
    
    @if(isAdmin || isTeamlead || isDepartmentAdmin){
      <!-- Checkbox Design -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <section class="example-section">
            <mat-checkbox class="example-margin" [checked]="isSelectAll" (change)="onSelectAll($event)"></mat-checkbox>
          </section>
        </th>
        <td mat-cell *matCellDef="let timesheet;let i = index">
          <section class="example-section">
            <mat-checkbox class="example-margin" *ngIf="userData.id != timesheet.userId" [checked]="timesheet.completed" (change)="update($event,i)"></mat-checkbox>
          </section>
        </td>
        <td mat-footer-cell *matFooterCellDef hidden></td>
      </ng-container>
    }
    
    
    <!-- Work Date Column -->
    <ng-container matColumnDef="workDate">
      <th mat-header-cell *matHeaderCellDef>Work Date</th>
      <td mat-cell *matCellDef="let timesheet">
        <span *ngIf="!timesheet.editing">{{ timesheet.workDate | date:'dd-MM-yyyy' }}</span>
        <mat-form-field appearance="outline" *ngIf="timesheet.editing">
          <input matInput [matDatepicker]="workDatePicker" [max]="today" [min]="minDate" [(ngModel)]="timesheet.workDate">
          <mat-datepicker-toggle matSuffix [for]="workDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #workDatePicker></mat-datepicker>
        </mat-form-field>
      </td>
      @if(isAdmin || isTeamlead || isDepartmentAdmin){
        <td mat-footer-cell *matFooterCellDef colspan="7" style="text-align: right;"> 
          <b>Total No. of hours</b>
        </td>
      }@else{
        <td mat-footer-cell *matFooterCellDef colspan="4" style="text-align: right;">
          <b>Total No. of hours</b>
        </td>
      }
    </ng-container>
    
    <!-- Category Column -->
    <ng-container matColumnDef="categoryId">
      <th mat-header-cell *matHeaderCellDef> Category </th>
      <td mat-cell *matCellDef="let timesheet ">
        <span *ngIf="!timesheet.editing">{{ timesheet.category }}</span>
        <mat-form-field appearance="outline" *ngIf="timesheet.editing">
          <mat-select [(ngModel)]="timesheet.categoryId" (selectionChange)="onCategorySelection($event.value,timesheet.id)">
            <mat-option *ngFor="let category of categoryList" [value]="category.id">{{ category.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef hidden></td>
    </ng-container>
    
    <!-- Activity Column -->
    <ng-container matColumnDef="activityId">
      <th mat-header-cell *matHeaderCellDef> Activity </th>
      <td mat-cell *matCellDef="let timesheet">
        <span *ngIf="!timesheet.editing">{{ timesheet.activity }}</span>
        <mat-form-field appearance="outline" *ngIf="timesheet.editing">
          <mat-select [(ngModel)]="timesheet.activityId">
            <mat-option [value]="-1" selected>--Select Activity--</mat-option>
            <mat-option *ngFor="let activity of activities" [value]="activity.id">{{ activity.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef hidden></td>
    </ng-container>
    
    @if(isAdmin || isTeamlead || isDepartmentAdmin){
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef> User Name </th>
        <td mat-cell *matCellDef="let timesheet">
          <span>{{ timesheet.userName }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef hidden></td>
      </ng-container>

      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef>Full Name</th>
        <td mat-cell *matCellDef="let timesheet">
            <span>{{ timesheet.fullName }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef hidden></td>
    </ng-container>
    }
    
    <!-- Work Done Column -->
    <!-- <ng-container matColumnDef="workDone">
      <th mat-header-cell *matHeaderCellDef>Work Description</th>
      <td mat-cell *matCellDef="let timesheet">
        <span *ngIf="!timesheet.editing">{{ timesheet.workDone }}</span>
        <mat-form-field appearance="outline" *ngIf="timesheet.editing">
          <input matInput type="text" [(ngModel)]="timesheet.workDone">
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef="let timesheet" hidden></td>
    </ng-container> -->
    <ng-container matColumnDef="workDone">
      <th mat-header-cell *matHeaderCellDef>Work Description</th>
      <td mat-cell *matCellDef="let timesheet">
        <span *ngIf="!timesheet.editing"
        [matTooltip]="timesheet.workDone"
        matTooltipPosition="above">{{ timesheet.workDone?.length > 50 
          ? (timesheet.workDone | slice:0:50) + '...' 
          : timesheet.workDone }}</span>
        <mat-form-field appearance="outline" *ngIf="timesheet.editing">
          <!-- <input matInput type="text" [(ngModel)]="timesheet.workDone"> -->
           <textarea
           matInput
           cdkTextareaAutosize
           #autosize="cdkTextareaAutosize"
           [(ngModel)]="timesheet.workDone"
           cdkAutosizeMaxRows="10"
           >
           </textarea>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef="let timesheet" hidden></td>
    </ng-container>

    <!-- Hours Worked Column -->
    <ng-container matColumnDef="noOfHours">
      <th mat-header-cell *matHeaderCellDef>Number Of Hours</th>
      <td mat-cell *matCellDef="let timesheet">
        <span *ngIf="!timesheet.editing">{{ timesheet.noOfHours }} hrs</span>
        <mat-form-field appearance="outline" *ngIf="timesheet.editing">
          <input type="number" step="0.1" min="0.1" max="10" matInput [(ngModel)]="timesheet.noOfHours" (change)="precision($event)" >
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef="let timesheet" colspan="5">
        <b>{{getTotalCost()}} hrs</b>
      </td>
    </ng-container>
    
    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let timesheet">
        <span>{{ timesheet.status == null ? timeSheetStatus[0].name : timeSheetStatus[timesheet.status].name }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef="let timesheet" hidden></td>
    </ng-container>
    
    <!-- Verified By Column -->
    <ng-container matColumnDef="verifiedBy">
      <th mat-header-cell *matHeaderCellDef>Verified By</th>
      <td mat-cell *matCellDef="let timesheet">
        <span>{{ timesheet.verifiedBy }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef="let timesheet" hidden></td>
    </ng-container>
    
    <!-- Verified On Column -->
    <ng-container matColumnDef="verifiedOn">
      <th mat-header-cell *matHeaderCellDef>Verified On</th>
      <td mat-cell *matCellDef="let timesheet">
        <span>{{ timesheet.verifiedOn | date:'dd/MMM/yyyy hh:mm:ss a' }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef="let timesheet" hidden></td>
    </ng-container>
    
    @if(isAdmin || isTeamlead || isDepartmentAdmin){
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let timesheet">
          <mat-slide-toggle *ngIf="!(userData.id == timesheet.userId)" class="example-margin" [checked]="timesheet.status == 1 ? true : false" 
          (change)="onStatusChange($event,timesheet)"></mat-slide-toggle>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef>Edit</th>
          <td mat-cell *matCellDef="let timesheet" >
            <button mat-raised-button color="primary" *ngIf="!timesheet.editing && userData.id == timesheet.userId" (click)="editTimesheet(timesheet)">Edit</button> &nbsp;
            <button mat-raised-button color="warn" *ngIf="!timesheet.editing && userData.id == timesheet.userId" (click)="deleteTimesheet(timesheet.id)">Delete</button> &nbsp;
            <button mat-raised-button color="primary" *ngIf="timesheet.editing && userData.id == timesheet.userId" (click)="saveTimesheet(timesheet)">Save</button> &nbsp;
            <button mat-raised-button *ngIf="timesheet.editing && userData.id == timesheet.userId" (click)="cancelEdit(timesheet)">Cancel</button>
          </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <!-- <tr mat-header-row *matHeaderRowDef="adminDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let timesheet; columns: adminDisplayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="adminDisplayedColumns"></tr> -->
      <tr mat-header-row *matHeaderRowDef="isAdmin ? adminDisplayedColumns : teamleadDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let timesheet; columns: isAdmin ? adminDisplayedColumns : teamleadDisplayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="isAdmin ? adminDisplayedColumns : teamleadDisplayedColumns"></tr>
    }@else{
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let timesheet">
          <button mat-raised-button color="primary" *ngIf="!timesheet.editing" (click)="editTimesheet(timesheet)">Edit</button> &nbsp;
          <button mat-raised-button color="warn" *ngIf="!timesheet.editing" (click)="deleteTimesheet(timesheet.id)">Delete</button> &nbsp;
          <button mat-raised-button color="primary" *ngIf="timesheet.editing" (click)="saveTimesheet(timesheet)">Save</button> &nbsp;
          <button mat-raised-button *ngIf="timesheet.editing" (click)="cancelEdit(timesheet)">Cancel</button>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    }
  </table>
</div>
</div>
